import { render } from "./footer.vue?vue&type=template&id=2b2ef7ed&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=2b2ef7ed&scoped=true&lang=less"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2ef7ed"]])

export default __exports__